import React, { useCallback } from "react";
import { connect, useDispatch } from "react-redux";
import { updateAssociationConfig } from "../../data/actions/associationActions";
import { IState } from "../../data/reducers/state";
import { IAssociation, IAssociationConfig } from "../../types/association/Association";
import { IPerson } from "../../types/persons/person";
import { Privilege } from "../../types/persons/privilege";
import { Role } from "../../types/persons/Role";
import AssociationConfigEditor from "./settings/AssociationConfigEditor";

interface AdminOverviewProps {
  // Redux props
  self: IPerson;
  privilege: Privilege;
  role: Role;
  // Direct props
  selectedAssociation: IAssociation | null;
  associations: IAssociation[];
}

/**
 * Admin overview tab content
 * Shows quick stats, actions, and help information
 */
const AdminOverview: React.FunctionComponent<AdminOverviewProps> = ({
  self,
  privilege,
  role,
  selectedAssociation,
  associations,
}) => {
  const dispatch = useDispatch();
  const canEdit = Privilege.canManage(privilege);
  const enabledTabsCount = canEdit ? 11 : 1; // Rough count based on permissions

  const handleConfigSave = useCallback(async (configUpdates: Partial<IAssociationConfig>) => {
    if (!selectedAssociation) {
      throw new Error("No association selected");
    }

    await dispatch(updateAssociationConfig(selectedAssociation._id, configUpdates) as any);
  }, [dispatch, selectedAssociation]);

  return (
    <div>
      {/* Current Association Info */}

      {/* Association Settings Editor */}
      {selectedAssociation && canEdit && (
        <AssociationConfigEditor
          association={selectedAssociation}
          onSave={handleConfigSave}
        />
      )}


    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  self: state.persons.self && state.persons.map[state.persons.self],
  privilege: state.auth.privilege,
  role: state.auth.role,
});

export default connect(mapStateToProps)(AdminOverview);
